import { takeLatest, call, put } from 'redux-saga/effects'
import lessonBlocksList from 'api/administration/blocks/List'
import * as fromActions from '../../actions/blocks.action'
import { onHttpError } from 'helpers/access.helper'

async function getList(lessonId: number) {
  return await lessonBlocksList(lessonId)
}

function* blockListEffectSaga(action: any) {
  try {
    const data = yield call(getList, action.lessonId)
    yield put(fromActions.Actions.getLessonBlocksListSuccess(data))
  } catch (error) {
    onHttpError(error)
    console.log('error: ', error)
  }
}

export function* blockListWatcherSaga() {
  yield takeLatest(fromActions.GET_LESSON_BLOCKS_LIST, blockListEffectSaga)
}
